import { Link, useLocation } from "react-router-dom";
import { HiChevronRight } from "react-icons/hi";

const Breadcrumb = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  const getBreadcrumbs = () => {
    const crumbs = [];
    if (pathSegments.length === 0) {
      return [{ name: "Dashboard", path: "/" }];
    }

    let path = "";
    for (let i = 0; i < pathSegments.length; i++) {
      path += `/${pathSegments[i]}`;
      const name = pathSegments[i]
        .replace(/-/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
      crumbs.push({ name, path });
    }
    return crumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <div className="flex justify-between items-center text-sm text-gray-600 py-2">
      <div className="font-semibold text-gray-800">CRM</div>
      <div className="flex items-center gap-2">
        <Link to="/" className="hover:text-primary">
          CRM
        </Link>
        {breadcrumbs.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            <HiChevronRight className="text-gray-400" />
            <span className="text-gray-800 font-semibold capitalize">
              {decodeURIComponent(item.name)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Breadcrumb;
